import React from "react";
import { Link } from "react-router-dom";
import gcashLogo from "../assets/payment/gcash.png";
import mastercardLogo from "../assets/payment/mastercard.png";
import mayaLogo from "../assets/payment/maya.png";
import qrphLogo from "../assets/payment/qrph.png";
import shopeeLogo from "../assets/payment/shopee.png";
import visaLogo from "../assets/payment/visa.png";

const paymentLogos = [
  { src: gcashLogo, alt: "GCash" },
  { src: mastercardLogo, alt: "Mastercard" },
  { src: mayaLogo, alt: "Maya" },
  { src: qrphLogo, alt: "QR Ph" },
  { src: shopeeLogo, alt: "ShopeePay" },
  { src: visaLogo, alt: "Visa" },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column footer-brand-column">
          <div className="footer-brand-lockup">
            <img
              src="/pngb-logo.jpg"
              alt="Asher Jewels PH"
              className="footer-logo"
            />
            <div className="footer-brand-copy">
              <h2 className="footer-title">Asher Jewels PH</h2>
              <p className="footer-tagline">Fine gold jewelry for gifting, collecting, and everyday elegance.</p>
            </div>
          </div>
          <p className="footer-description">
            Number one retail and wholesale supplier of gold jewelries in the Philippines.
          </p>
          <p className="footer-note">
            This website is the official online platform of PNGB Asher Jewels Store for product browsing,
            customer orders, and account support.
          </p>
          <div className="footer-highlights">
            <span className="footer-highlight-pill">Trusted gold pieces</span>
            <span className="footer-highlight-pill">Fast customer support</span>
            <span className="footer-highlight-pill">Nationwide delivery</span>
          </div>
          <div className="footer-payment-strip">
            <h3 className="footer-payment-title">Accepted Payment Channels</h3>
            <div className="payment-logo-grid payment-logo-grid--footer" aria-label="Accepted payment channels">
              {paymentLogos.map((logo) => (
                <div key={logo.alt} className="payment-logo-card payment-logo-card--footer">
                  <img src={logo.src} alt={logo.alt} className="payment-logo-image" />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">Customer Care</h3>
          <ul className="footer-links">
            <li><Link to="/account">My Account</Link></li>
            <li><Link to="/wishlist">My Wishlist</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/returns">Returns & Exchanges</Link></li>
            <li><Link to="/shipping">Shipping & Delivery</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">Reach Us</h3>
          <div className="footer-contact-list">
            <div className="footer-contact-card">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z" /></svg>
              </span>
              <div>
                <strong>Visit us</strong>
                <p>Blk 3 Lot 3 Orchard Avenue St., The Orchard Residence, Salitran 1, Dasmarinas, Cavite, Philippines 4114</p>
              </div>
            </div>
            <div className="footer-contact-card">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.32.56 3.58.56a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.3 21 3 13.7 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.26.19 2.46.56 3.58a1 1 0 0 1-.24 1.01l-2.2 2.2Z" /></svg>
              </span>
              <div>
                <strong>Call</strong>
                <p><a href="tel:+639707578888">+63 970 757 8888</a></p>
              </div>
            </div>
            <div className="footer-contact-card">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M4 6h16a2 2 0 0 1 2 2v.35l-10 6.15L2 8.35V8a2 2 0 0 1 2-2Zm18 4.72V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.28l9.48 5.84a1 1 0 0 0 1.04 0L22 10.72Z" /></svg>
              </span>
              <div>
                <strong>Email</strong>
                <p><a href="mailto:pngbcustomerservice@gmail.com">pngbcustomerservice@gmail.com</a></p>
              </div>
            </div>
            <div className="footer-contact-card">
              <span className="footer-contact-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" role="presentation" focusable="false"><path d="M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1Zm1 11.41l3.29 3.3l-1.41 1.41L11 13V6h2Z" /></svg>
              </span>
              <div>
                <strong>Delivery</strong>
                <p>Shipping lead time: 1 to 3 days for available items.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">Shopping Notes</h3>
          <div className="footer-note-card">
            <p>All jewelry listings are subject to stock confirmation before dispatch.</p>
            <p>Orders placed through your account can be reviewed anytime under My Account and Orders.</p>
            <p>For urgent follow-ups, contact customer service and provide your order code.</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-bottom__brand">Asher Jewels PH</span>
        <span className="footer-bottom__dot" aria-hidden="true">|</span>
        <span>2026 All rights reserved.</span>
      </div>
    </footer>
  );
}

